module.exports = __webpack_public_path__ + "static/media/2016-Mustang-Coupe-V6.bcb79062.webp";